/**************************************************
 * Nombre:       Home_Categorias
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tarjeta_Categoria from "../../Tarjetas/Tarjeta_Categoria";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {useContext, useEffect, useState} from "react";
import {contexApp} from "../../../App";
import {TituloTexto} from "./SubComponentes/TituloTexto";

const Home_Categorias = () => {
    const cData = useContext(contexApp)
    const {sCell} = useResponsive()
    const [configuraciones, setConfiguraciones] = useState({})

    const obtenerImg = (cat) => {

        switch (cat) {
            case 'SUPERIOR' :
                return configuraciones.imgSuperior
            case 'INFERIOR' :
                return configuraciones.imgInferior
            case 'ACCESORIOS' :
                return configuraciones.imgAccesorios

        }

    }

    useEffect(() => {


        if (cData.configuraciones && cData.configuraciones.length > 0) {
            setConfiguraciones(cData.configuraciones[0])
        }

    }, [cData.configuraciones]);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: sCell ? 3 : 6}}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <TituloTexto texto={'TODAS LAS'} titulo={'CATEGORIAS'} dir={'center'}/>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'center', mt: sCell ? 8 : 10}}>
                    <Grid
                        container
                        justifyContent={sCell ? 'center' : 'space-between'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={sCell ? 4 : 4}
                    >

                        {categorias.map((it, index) => {
                            return (
                                <Grid container size={{xs: 6, sm: 4, md: 4}}>
                                    <Tarjeta_Categoria item={it} img={obtenerImg(it.nombre)}/>
                                </Grid>
                            )
                        })}


                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Home_Categorias

const categorias = [
    {
        nombre: 'SUPERIOR',


    },
    {
        nombre: 'INFERIOR',


    },
    {
        nombre: 'ACCESORIOS',


    },
]